import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DomainDataService } from '../../../../../services';
import { VolunteeringAreaService } from '../../../volunteering-area.service';

interface TopicsStatus {
	topicId: number,
	topicName: string,
	eventsCount: number,
	missingSpecialistsCount: number,
}

@Component({
	selector: 'volunteering-specialists-tab-1-part',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './volunteering-specialists-tab-1.part.html',
})

export class VolunteeringSpecialistsTab1Part {

	private util = inject(UtilityService);
	private areaService = inject(VolunteeringAreaService);
	private domainDataService = inject(DomainDataService);

	public topicsStatus = computed<TopicsStatus[]>(() => {

		const topicsStatus: TopicsStatus[] = [];

		const data = this.areaService.volunteeringData();
		if (!data) return topicsStatus;

		const topics = this.domainDataService.data().topics.filter(t => t.enabled && t.needsSpecialist);

		const topicAssignmentsMap = this.util.array.toArrayMap(data.sessionTopicAssignments, t => t.topicId)

		topics.forEach(t => {
			const topicMap = topicAssignmentsMap[t.topicId];
			if (topicMap) {

				topicsStatus.push({
					topicId: t.topicId,
					topicName: t.name,
					eventsCount: topicMap.length,
					missingSpecialistsCount: topicMap.filter(v => v.assignedSpecialists.length === 0).length,
				})
			} else {
				topicsStatus.push({
					topicId: t.topicId,
					topicName: t.name,
					eventsCount: 0,
					missingSpecialistsCount: 0,
				})
			}
		});

		return topicsStatus;
	});

}
